var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_51519",
    "data-name": "Raggruppa 51519",
    transform: "translate(-1332 -5029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4",
    "data-name": "Ellisse 4",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1332 5029)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_34859",
    "data-name": "Tracciato 34859",
    d: "M-384.269-755.863a9.923,9.923,0,0,0-5.775-2.249l-.287.342a13.481,13.481,0,0,1,5.117,2.721,16.824,16.824,0,0,0-15.354-.621c-.76.365-1.214.621-1.214.621a13.645,13.645,0,0,1,5.409-2.811l-.2-.252a9.915,9.915,0,0,0-5.773,2.249,29.692,29.692,0,0,0-2.964,12.492,7.358,7.358,0,0,0,6.267,3.256s.76-.964,1.377-1.779a6.382,6.382,0,0,1-3.6-2.528c.3.22.8.507.841.536a14.436,14.436,0,0,0,12.823.75,11.636,11.636,0,0,0,2.363-1.265,6.473,6.473,0,0,1-3.72,2.55c.617.814,1.357,1.735,1.357,1.735a7.413,7.413,0,0,0,6.287-3.256A29.664,29.664,0,0,0-384.269-755.863Zm-12.882,10.5a2.339,2.339,0,0,1-2.121-2.213,2.354,2.354,0,0,1,2.121-2.548h.031a2.234,2.234,0,0,1,2.064,2.379v0A2.246,2.246,0,0,1-397.151-745.362Zm9.6-2.38a2.132,2.132,0,0,1-2.276,2,2.169,2.169,0,0,1-1.917-2.371,2.14,2.14,0,0,1,2.1-2.007,2.247,2.247,0,0,1,2.1,2.376Z",
    transform: "translate(1745.311 5797.112)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.82645846d56a45393c301522100c4a3a.svg";
export { ForwardRef as ReactComponent };